/**
 * @author xiaohuangmaoth
 * @description 个人证书明细
 * @Date 2021/03/02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizBrowserExport } = component_tool

class PersonnelCertificateAcquisitionDetails extends WizContainer {
  componentName = "PersonnelCertificateAcquisitionDetails";

  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res

    if (success) {
      const rows = data.map(val => ({
        ...val,
        accountState: val.accountState ? '激活' :'禁用',
        type: val.type === 1 ? '培训证书' : val.type === 2 ? '社会证书' : '',
        ifApply: val.ifApply ? '适用' :'不适用',
      }))

      const title = '个人证书明细'

      WizBrowserExport({
        title,
        sheetName: title,
        columns: column.filter((_, index) => index),
        rows,
        filename: title + '.xlsx',
      })
      return true

    } else {
      wizNotice.error(msg)
      return false;
    }

  }

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: this.handleFile
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(() => ({}))(PersonnelCertificateAcquisitionDetails);
